(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["annissa-announcement-bar"] && !Shopify.designMode) return;
  try {
    
  class AnnissaAnnouncementBar extends HTMLElement {
    connectedCallback() {
      this.slides = Array.from(this.querySelectorAll('.annissa-announcement-bar__slide'));
      this.currentIndex = 0;

      if (this.slides.length === 0) return;

      this.slides.forEach((slide, i) => {
        slide.classList.toggle('annissa-announcement-bar__slide--current', i === 0);
        slide.setAttribute('aria-hidden', i === 0 ? 'false' : 'true');
      });

      if (this.slides.length > 1) {
        this.scheduleNext();
      }
    }

    disconnectedCallback() {
      if (this.rotationTimeout) clearTimeout(this.rotationTimeout);
    }

    scheduleNext() {
      const currentSlide = this.slides[this.currentIndex];
      const duration = parseFloat(currentSlide.dataset.duration) || 5;

      this.rotationTimeout = setTimeout(() => {
        this.goToNext();
        this.scheduleNext();
      }, duration * 1000);
    }

    goToNext() {
      const outgoingSlide = this.slides[this.currentIndex];
      this.currentIndex = (this.currentIndex + 1) % this.slides.length;
      const incomingSlide = this.slides[this.currentIndex];

      outgoingSlide.classList.remove('annissa-announcement-bar__slide--current');
      outgoingSlide.classList.add('annissa-announcement-bar__slide--leaving');
      outgoingSlide.setAttribute('aria-hidden', 'true');

      incomingSlide.classList.add('annissa-announcement-bar__slide--current');
      incomingSlide.setAttribute('aria-hidden', 'false');

      window.setTimeout(() => {
        outgoingSlide.classList.remove('annissa-announcement-bar__slide--leaving');
      }, 500);
    }
  }

  customElements.define('annissa-announcement-bar', AnnissaAnnouncementBar);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["annissaa-newsletter"] && !Shopify.designMode) return;
  try {
    
(function() {
  var btn = document.querySelector('#annissaa-klaviyo-form [data-klaviyo-list]');
  if (!btn) return;

  btn.addEventListener('click', function() {
    var input = document.querySelector('#annissaa-klaviyo-email');
    var listId = btn.dataset.klaviyoList;
    if (!input || !input.value || !listId) return;

    btn.disabled = true;

    fetch('https://a.klaviyo.com/client/subscriptions/?company_id=' + encodeURIComponent(listId), {
      method: 'POST',
      headers: { 'content-type': 'application/json', 'revision': '2023-02-22' },
      body: JSON.stringify({
        data: {
          type: 'subscription',
          attributes: {
            list_id: listId,
            email: input.value
          }
        }
      })
    })
    .then(function() {
      document.getElementById('annissaa-klaviyo-form').style.display = 'none';
      document.getElementById('annissaa-klaviyo-success').style.display = 'block';
    })
    .catch(function() {
      btn.disabled = false;
    });
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
